










import { ComboboxOptions } from '@/components/ui/DynamicTechTaskCard/types/input-field'
import { Component } from 'vue-property-decorator'
import InputFieldMixin from '@/dynamic-tech-task/components/input/mixins/input-field'


@Component
export default class ComboboxInputField extends InputFieldMixin<ComboboxOptions> {}
